import { createHttpRequest } from '../utils/services'
import {
    EVENT_BY_SLUG_ENDPOINT,
    EVENT_GAMES_BY_SLUG_ENDPOINT,
    GAME_SETTINGS_ENDPOINT,
    GAME_STATS_ENDPOINT,
} from '../config/endpoints'

export const gameServices = {
    /**
     * getEventBySlug : l'événement lui-même, par son slug (15/10) — son
     * habillage, qu'il ait des jeux ou non. Même jeton d'aperçu que les jeux.
     * Rend `null` si le back refuse (lien invalide, expiré, ou pas d'événement).
     */
    async getEventBySlug(slug: string, preview?: string) {
        let endpoint = EVENT_BY_SLUG_ENDPOINT.replace(':slug', slug)
        if (preview) {
            endpoint += `?preview=${encodeURIComponent(preview)}`
        }
        const res = await createHttpRequest(endpoint, { method: 'GET' })
        return res && !res.error?.length && res.data?._id ? res.data : null
    },

    /**
     * Compte une vue ou un clic sur la carte d'un jeu (06/10). Sans retour
     * attendu : un compteur manqué ne doit jamais gêner le joueur.
     *
     * @param {string} eventGameId la séance du jeu
     * @param {'views' | 'clicks'} kind
     */
    async countStat(eventGameId: string, kind: 'views' | 'clicks') {
        if (!eventGameId) return
        await createHttpRequest(GAME_STATS_ENDPOINT, {
            method: 'POST',
            params: [{ _id: eventGameId, [kind]: 1 }]
        }).catch(() => undefined)
    },

    /**
     * getSettings get game settings
     *
     * @param {string} place
     * @return {*}
     */
    async getSettings(place: string) {
        const endpoint = GAME_SETTINGS_ENDPOINT.replace(':slug', place)
        const res = await createHttpRequest(endpoint, { method: 'GET' })
        if (!res.error.length) {
            return res.data
        } else {
            return res.error
        }
    },

    /**
     * getEventGamesBySlug : jeux d'un event précis via son slug (URL /e/:slug).
     * Un token preview (?preview=) est requis si l'event n'est pas actif.
     *
     * @param {string} slug
     * @param {string} preview optional signed preview token
     * @return {*}
     */
    async getEventGamesBySlug(slug: string, preview?: string) {
        // NB : on ajoute ?preview directement dans l'URL (pas via params) car
        // createHttpRequest met un body sur GET si params est fourni -> fetch throw.
        let endpoint = EVENT_GAMES_BY_SLUG_ENDPOINT.replace(':slug', slug)
        if (preview) {
            endpoint += `?preview=${encodeURIComponent(preview)}`
        }
        const res = await createHttpRequest(endpoint, { method: 'GET' })
        if (!res.error.length) {
            return res.data
        } else {
            return res.error
        }
    },
}
